// extracted by mini-css-extract-plugin
export default {"featuredLogo":"styles_featuredLogo__3Hlwm","title":"styles_title__VovoD","slider":"styles_slider__AFqUt"};